import { buildURL } from "@comparaonline/cloudinary-image";

const transformation = ["f_auto", "q_auto", "dpr_auto"];

export const MAIN_ATTRIBUTE_URL = buildURL(
  "v1564412265/assets/placeholders/main-attribute.svg",
  transformation
);

export const CTA_BUTTON_URL = buildURL(
  "v1564412265/assets/placeholders/cta-button.svg",
  transformation
);

export const PRODUCT_LOGO_URL = buildURL(
  "v1564412265/assets/placeholders/product-logo.svg",
  transformation
);

export const HORIZONTAL_BAR = buildURL("v1564598096/assets/placeholders/horizontal-bar.svg");

export const MAX_PLACEHOLDER_BARS = 5;
